import React, { FC } from 'react';
import { ProvidersListPage } from './provider-list.page';
import { ProviderColumnName } from '../../hooks/providers-table-columns.hook';
import { AllowedProviderActions } from '../../components/providers-table/providers-table-actions.component';

export const ProvidersListAdminLevelPage: FC = () => {
	const providerColumnsList: ProviderColumnName[] = [
		'fullName',
		'targetLanguage',
		'verificationType',
		'workStatus',
		'serviceType',
		'totalEngagements',
		'district',
		'actions',
	];
	const allowedProviderActions: AllowedProviderActions[] = ['view', 'delete', 'edit'];

	return (
		<ProvidersListPage
			isAdminRoute={true}
			providerColumnsList={providerColumnsList}
			allowedProviderActions={allowedProviderActions}
		/>
	);
};
